<template>
    <main id="mainCtrl">
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li id="tabSettings">
                    <a href="/clinics/feedback/settings">Основные</a>
                </li>
                <li class="active" id="tabAppearance">
                    <a href="#">Внешний вид</a>
                </li>
            </ul>
        </div>

        <ValidationObserver ref="validator">
            <div class="appearanceSettingsForm" v-cloak>
                <Alert>Для изменения настроек внешнего вида обратитесь, пожалуйста, к персональному менеджеру.</Alert>

                <div class="appearanceSettingsRow">
                    <div class="clinic-review-service-iphone-message phonePreview">
                        <div class="message">{{ settings.message_text ? prepareTextForPreview(settings.message_text) : 'Олег, вам понравилось в ' + this.clinicNamePrepositional + '? Поделитесь мнением о качестве обслуживания в медицинском центре на сайте: https://doctu.ru/' }}</div>
                    </div>

                    <fieldset :disabled="!isSupport">
                        <legend>Сообщение</legend>

                        <label>Текст</label>
                        <vee-textarea v-model="settings.message_text"
                                      ref="messageText"
                                      :rules="{required: true, max: 500}"
                                      name="Текст сообщения"
                                      :disabled="!isSupport"
                                      @input="setTextareaHeight"
                                      :ta-class="messageTextError ? 'appearanceSettingsText hasError' : 'appearanceSettingsText'"
                                      v-tooltip.left="{
                                          content: messageTextError,
                                          template: $errTemplate,
                                      }"/>

                        <button :disabled="!isSupport" class="tiny" @click.prevent="setDefaultMessageText">
                            Стандартный текст
                        </button>
                    </fieldset>
                </div>

                <div class="appearanceSettingsRow">
                    <div class="clinic-review-wrap phonePreview">
                        <div class="clinic-review-service">
                            <section class="clinic-review-service__slide slide-1">
                                <h1 class="clinic-review-service__title">
                                    {{ settings.review_title ? settings.review_title : 'Вам понравилось в ' + clinicNamePrepositional + '?' }}
                                </h1>
                                <p class="clinic-review-service__txt">{{ settings.review_text ? settings.review_text : 'Поделитесь мнением о качестве обслуживания в медицинском центре.' }}</p>
                                <div class="form-actions">
                                    <button type="button" class="btn btn-green">
                                        <svg width="16" height="16" viewBox="0 0 17 17">
                                            <path d="M15.616 11.0408C16.3016 10.87 16.5269 9.89924 16.4975 9.42283C16.4681 8.89248 16.0959 8.03854 15.5572 7.96663C15.7531 7.79584 15.9882 7.31943 15.8511 6.57335C15.714 5.80031 15.0577 5.18008 14.3623 5.27895C14.2742 5.28794 12.8149 5.43176 11.7669 5.58458C10.7189 5.73739 10.6699 5.62053 10.6699 5.62053C11.522 3.93062 12.1391 -0.114376 9.11263 0.00247912C8.35847 0.146301 9.46522 2.29464 7.93732 4.17332C7.52596 4.68569 6.90892 5.18008 5.99805 5.61154C5.51813 5.89919 5.0676 6.2947 4.80315 6.6183C4.47994 7.0228 4.36241 7.35539 3.92167 7.52617C2.81492 7.94865 1.78652 7.84079 1.29681 7.7509C1.13031 7.72393 0.963805 7.81382 0.914834 7.96663C0.0529395 10.6993 0.758126 12.9555 1.03237 13.6656C1.08134 13.8004 1.22825 13.8813 1.38496 13.8543C2.11953 13.7645 2.70718 13.7645 3.59846 13.8364C4.46036 13.9083 4.94027 14.5015 5.59649 14.8971C7.06563 15.8858 9.20078 15.8139 11.1988 15.769C11.6298 15.76 12.0509 15.8229 12.4525 15.8589C12.6581 15.9128 12.8736 15.9488 13.1087 15.9757C14.0196 16.0926 14.4505 15.778 14.6758 15.2386C14.8716 14.7712 14.7933 14.2678 14.3428 13.8184C14.4407 13.8364 14.5289 13.8543 14.5974 13.8723C15.4789 14.0251 15.9882 13.324 16.1155 12.5959C16.2135 11.9847 16.0078 11.2745 15.5964 11.0408H15.616Z" fill="#FFCA28"/>
                                            <path d="M12.3056 10.7711C12.3056 10.7711 11.8158 10.5105 11.7375 10.1689C11.6591 9.81832 11.6493 9.64753 11.6395 9.38685C11.62 8.95539 12.0607 8.66774 12.0607 8.66774L12.0901 8.15538C12.0901 8.15538 11.6395 7.8947 11.5318 7.8138C11.3555 7.68795 11.2576 7.21154 11.287 6.96884C11.3065 6.79805 11.522 6.48344 11.522 6.48344C10.474 6.54637 10.4251 7.66099 10.4349 8.02953C10.4544 8.46999 10.239 9.07224 9.93534 9.53966C9.54357 10.1419 8.17238 10.9419 8.10382 10.9779C8.89715 11.2835 9.38687 12.1554 9.57296 12.8116C9.6611 13.1352 10.0627 14.6364 10.3173 14.8701C10.3859 14.96 11.0421 15.3555 11.4828 15.4184C11.4828 15.4184 11.0617 14.9869 11.287 14.2948C11.4632 13.7375 12.0313 13.6116 12.0313 13.6116L12.286 13.2161C12.286 13.2161 11.9236 12.9105 11.8452 12.6139C11.7767 12.3622 11.7179 11.7869 11.9432 11.5262C12.0411 11.4094 12.3349 11.2655 12.3349 11.2655L12.3056 10.7891V10.7711Z" fill="#FFB300"/>
                                            <path d="M6.47797 5.44073C6.24291 5.73737 5.4104 6.60929 5.22431 6.81603C5.03822 7.02278 4.33303 7.95762 4.09797 8.25425H4.0392C4.049 7.93065 4.22529 7.20255 4.76398 6.47445C5.32225 5.80029 6.13517 5.50366 6.45838 5.3868L6.47797 5.44073ZM14.8716 10.852C12.8932 10.8071 11.238 10.7172 11.238 10.7172C11.238 10.7172 10.6503 10.6992 10.5916 9.7554C10.5524 9.0273 11.1107 8.81156 11.4045 8.75763C12.0215 8.7037 14 8.43403 14.6268 8.34414C15.2928 8.25425 15.5475 7.9756 15.5475 7.9756C15.5475 7.9756 15.2438 7.83178 14.7149 7.90369C14.1861 7.9756 12.6386 8.10144 11.6298 8.19133C11.473 8.20931 11.1205 8.09245 10.9637 7.59807C10.8168 7.13064 11.0617 6.78008 11.1988 6.67221C11.4339 6.48344 12.7169 5.97108 13.6963 5.73737C14.8619 5.45871 15.567 5.92613 15.567 5.92613C15.3418 5.26994 14.5582 5.17107 13.8335 5.225C13.2948 5.26096 11.2086 5.60253 10.9442 5.55759C10.856 5.55759 10.7874 5.52163 10.8168 5.44972C11.0421 4.75758 11.3065 3.65195 11.3065 3.39127C11.3065 3.24745 11.189 3.3643 11.14 3.49015C10.7972 4.32611 9.93534 5.42276 9.99411 6.56434C10.0235 7.0048 10.1606 8.01155 9.8472 8.79359C9.26933 10.2498 8.04505 10.7711 8.01567 10.8251C7.98629 10.879 7.99608 10.9599 8.06464 10.9869C8.27032 10.9959 8.476 10.924 8.67189 10.861C9.12242 10.6363 9.55337 10.3846 9.96473 10.106C10.0333 10.6543 10.2977 10.9689 10.6014 11.1307C10.1802 11.6161 10.2586 12.9644 10.7581 13.288C10.4446 13.4498 10.2879 13.7375 10.1998 14.0431C10.0333 14.6543 10.2292 14.924 10.4936 15.2027C10.4936 15.2027 8.9853 15.4723 7.13419 15.1487C5.4104 14.8431 5.4104 13.5667 3.52011 13.5667C1.62982 13.5667 0.660183 13.9442 1.60043 13.8543C2.66801 13.7555 3.38299 13.9083 3.90208 13.9442C4.79336 14.0161 5.02842 15.0229 7.00686 15.5622C8.40744 15.9398 11.3457 15.778 11.3457 15.778C11.3457 15.778 12.7071 16.0296 12.9226 15.9757C12.9226 15.9757 11.2967 15.4454 10.9344 15.0498C10.8658 14.9779 10.5328 14.6274 10.9344 13.8903C11.0421 13.6925 11.4926 13.5667 11.7963 13.5757C11.904 13.5847 12.5798 13.7285 13.8041 13.9442C14.6268 14.097 14.7737 14.7442 14.7737 14.7442C14.7737 14.7442 14.901 13.7555 14.0293 13.5757C13.1968 13.3959 12.0117 13.1532 11.6787 13.0723C11.3457 12.9914 10.9637 12.7038 10.9833 12.0476C10.9931 11.4813 11.3653 11.2835 11.571 11.2745C11.7865 11.2655 13.5298 11.3105 14.7933 11.3374C15.3222 11.3374 15.616 11.0678 15.616 11.0678C15.616 11.0678 15.4005 10.879 14.8521 10.861L14.8716 10.852Z" fill="#EDA600"/>
                                        </svg>
                                        {{ settings.like_button_text ? settings.like_button_text : 'Да, все отлично' }}
                                    </button>
                                    <button type="button" class="btn btn-white">
                                        <svg width="16" height="16" viewBox="0 0 16 16">
                                            <path d="M15.116 4.95917C15.8016 5.12996 16.0269 6.10076 15.9975 6.57717C15.9681 7.10752 15.5959 7.96146 15.0572 8.03337C15.2531 8.20416 15.4882 8.68057 15.3511 9.42665C15.214 10.1997 14.5577 10.8199 13.8623 10.721C13.7742 10.7121 12.3149 10.5682 11.2669 10.4154C10.2189 10.2626 10.1699 10.3795 10.1699 10.3795C11.022 12.0694 11.6391 16.1144 8.61263 15.9975C7.85847 15.8537 8.96522 13.7054 7.43732 11.8267C7.02596 11.3143 6.40892 10.8199 5.49805 10.3885C5.01813 10.1008 4.5676 9.7053 4.30315 9.3817C3.97994 8.9772 3.86241 8.64461 3.42167 8.47383C2.31492 8.05135 1.28652 8.15921 0.79681 8.2491C0.630308 8.27607 0.463805 8.18618 0.414834 8.03337C-0.44706 5.30075 0.258126 3.04454 0.532365 2.33442C0.581336 2.19959 0.72825 2.11868 0.884958 2.14565C1.61953 2.23554 2.20718 2.23554 3.09846 2.16363C3.96036 2.09172 4.44027 1.49845 5.09649 1.10294C6.56563 0.114165 8.70078 0.186076 10.6988 0.23102C11.1298 0.240009 11.5509 0.177088 11.9525 0.141132C12.1581 0.0871992 12.3736 0.0512428 12.6087 0.0242758C13.5196 -0.0925789 13.9505 0.222032 14.1758 0.761365C14.3716 1.22879 14.2933 1.73216 13.8428 2.18161C13.9407 2.16363 14.0289 2.14565 14.0974 2.12767C14.9789 1.97486 15.4882 2.676 15.6155 3.4041C15.7135 4.01534 15.5078 4.72546 15.0964 4.95917H15.116Z" fill="#FFCA28"/>
                                            <path d="M11.8056 5.22886C11.8056 5.22886 11.3158 5.48954 11.2375 5.83111C11.1591 6.18168 11.1493 6.35247 11.1395 6.61315C11.12 7.04461 11.5607 7.33226 11.5607 7.33226L11.5901 7.84462C11.5901 7.84462 11.1395 8.1053 11.0318 8.1862C10.8555 8.31205 10.7576 8.78846 10.787 9.03116C10.8065 9.20195 11.022 9.51656 11.022 9.51656C9.97403 9.45363 9.92506 8.33901 9.93485 7.97047C9.95444 7.53001 9.73897 6.92776 9.43534 6.46034C9.04357 5.85808 7.67238 5.05807 7.60382 5.02211C8.39715 4.71649 8.88687 3.84457 9.07296 3.18838C9.1611 2.86478 9.56267 1.36364 9.81732 1.12993C9.88588 1.04004 10.5421 0.644528 10.9828 0.581606C10.9828 0.581606 10.5617 1.01307 10.787 1.70522C10.9632 2.26253 11.5313 2.38837 11.5313 2.38837L11.786 2.78388C11.786 2.78388 11.4236 3.0895 11.3452 3.38614C11.2767 3.63783 11.2179 4.21311 11.4432 4.47379C11.5411 4.59065 11.8349 4.73447 11.8349 4.73447L11.8056 5.21088V5.22886Z" fill="#FFB300"/>
                                            <path d="M5.97797 10.5593C5.74291 10.2626 4.9104 9.39071 4.72431 9.18397C4.53822 8.97722 3.83303 8.04238 3.59797 7.74575H3.5392C3.549 8.06935 3.72529 8.79745 4.26398 9.52555C4.82225 10.1997 5.63517 10.4963 5.95838 10.6132L5.97797 10.5593ZM14.3716 5.14796C12.3932 5.1929 10.738 5.28279 10.738 5.28279C10.738 5.28279 10.1503 5.30077 10.0916 6.2446C10.0524 6.9727 10.6107 7.18844 10.9045 7.24237C11.5215 7.2963 13.5 7.56597 14.1268 7.65586C14.7928 7.74575 15.0475 8.0244 15.0475 8.0244C15.0475 8.0244 14.7438 8.16822 14.2149 8.09631C13.6861 8.0244 12.1386 7.89856 11.1298 7.80867C10.973 7.79069 10.6205 7.90755 10.4637 8.40193C10.3168 8.86936 10.5617 9.21992 10.6988 9.32779C10.9339 9.51656 12.2169 10.0289 13.1963 10.2626C14.3619 10.5413 15.067 10.0739 15.067 10.0739C14.8418 10.7301 14.0582 10.8289 13.3335 10.775C12.7948 10.739 10.7086 10.3975 10.4442 10.4424C10.356 10.4424 10.2874 10.4784 10.3168 10.5503C10.5421 11.2424 10.8065 12.3481 10.8065 12.6087C10.8065 12.7526 10.689 12.6357 10.64 12.5099C10.2972 11.6739 9.43534 10.5772 9.49411 9.43566C9.52349 8.9952 9.66061 7.98845 9.3472 7.20641C8.76933 5.75021 7.54505 5.22886 7.51567 5.17493C7.48629 5.12099 7.49608 5.04009 7.56464 5.01313C7.77032 5.00414 7.976 5.07605 8.17189 5.13897C8.62242 5.36369 9.05337 5.61538 9.46473 5.89404C9.53329 5.34571 9.79773 5.0311 10.1014 4.8693C9.6802 4.3839 9.75856 3.03557 10.2581 2.71197C9.94465 2.55017 9.78794 2.26253 9.69979 1.95691C9.53329 1.34566 9.72917 1.07599 9.99362 0.797338C9.99362 0.797338 8.4853 0.527672 6.63419 0.851272C4.9104 1.15689 4.9104 2.43332 3.02011 2.43332C1.12982 2.43332 0.160183 2.05578 1.10043 2.14567C2.16801 2.24455 2.88299 2.09174 3.40208 2.05578C4.29336 1.98387 4.52842 0.977115 6.50686 0.437781C7.90744 0.0602484 10.8457 0.22205 10.8457 0.22205C10.8457 0.22205 12.2071 -0.0296402 12.4226 0.0242939C12.4226 0.0242939 10.7967 0.554639 10.4344 0.95015C10.3658 1.02206 10.0328 1.37263 10.4344 2.10972C10.5421 2.30747 10.9926 2.43332 11.2963 2.42433C11.404 2.41534 12.0798 2.27151 13.3041 2.05578C14.1268 1.90297 14.2737 1.25577 14.2737 1.25577C14.2737 1.25577 14.401 2.24455 13.5293 2.42433C12.6968 2.6041 11.5117 2.8468 11.1787 2.9277C10.8457 3.00861 10.4637 3.29625 10.4833 3.95244C10.4931 4.51874 10.8653 4.71649 11.071 4.72548C11.2865 4.73447 13.0298 4.68953 14.2933 4.66256C14.8222 4.66256 15.116 4.93223 15.116 4.93223C15.116 4.93223 14.9005 5.12099 14.3521 5.13897L14.3716 5.14796Z" fill="#EDA600"/>
                                        </svg>
                                        {{ settings.dislike_button_text ? settings.dislike_button_text : 'Нет, есть претензии' }}
                                    </button>
                                </div>
                                <div class="agreement">
                                    Выражая свое мнение о&nbsp;качестве обслуживания, вы&nbsp;соглашаетесь с&nbsp;<a href="#">правилами сервиса</a>.
                                </div>
                            </section>
                        </div>
                    </div>

                    <fieldset :disabled="!isSupport">
                        <legend>Оценка</legend>

                        <label>Заголовок</label>
                        <vee-input v-model="settings.review_title"
                                   ref="reviewTitle"
                                   :rules="{required: true, max: 200}"
                                   :disabled="!isSupport"
                                   name="Заголовок оценки"/>

                        <label>Текст</label>
                        <vee-textarea v-model="settings.review_text"
                                      ref="reviewText"
                                      :rules="{required: true, max: 500}"
                                      :disabled="!isSupport"
                                      @input="setTextareaHeight"
                                      ta-class="appearanceSettingsText"
                                      name="Текст оценки"/>

                        <label>Кнопка "Понравилось"</label>
                        <vee-input v-model="settings.like_button_text"
                                   ref="likeButtonText"
                                   :rules="{required: true, max: 30}"
                                   :disabled="!isSupport"
                                   name='Кнопка "Понравилось"'/>

                        <label>Кнопка "НЕ понравилось"</label>
                        <vee-input v-model="settings.dislike_button_text"
                                   ref="dislikeButtonText"
                                   :rules="{required: true, max: 30}"
                                   :disabled="!isSupport"
                                   name='Кнопка "НЕ понравилось"'/>

                        <button :disabled="!isSupport" class="tiny" @click.prevent="setDefaultReviewText">
                            Стандартный текст
                        </button>
                    </fieldset>
                </div>

                <div class="appearanceSettingsRow">
                    <div class="clinic-review-wrap phonePreview">
                        <div class="clinic-review-service">
                            <section class="clinic-review-service__slide slide-2">
                                <h2 class="clinic-review-service__title">
                                    {{ settings.map_links_title ? settings.map_links_title : 'Оставьте отзыв о ' + clinicNamePrepositional }}
                                </h2>
                                <p class="clinic-review-service__txt">{{ settings.map_links_text ? settings.map_links_text : 'Поделитесь своим отзывом с другими пациентами на любом из сайтов на выбор.' }}</p>
                                <div class="form-actions">
                                    <button v-if="isDoctuOn" type="button" class="btn btn-white">
                                        <svg width="16" height="16" viewBox="0 0 17 16">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.91671 12.4236C11.4606 12.4236 14.3334 9.64247 14.3334 6.21179C14.3334 2.78111 11.4606 0 7.91671 0C4.37286 0 1.5 2.78111 1.5 6.21179C1.5 9.64247 4.37286 12.4236 7.91671 12.4236ZM7.91676 9.58909C9.84352 9.58909 11.4055 8.07702 11.4055 6.21179C11.4055 4.34655 9.84352 2.83448 7.91676 2.83448C5.98999 2.83448 4.42804 4.34655 4.42804 6.21179C4.42804 8.07702 5.98999 9.58909 7.91676 9.58909Z" fill="#13A546"/>
                                            <path d="M11.0158 12.2491L13.9048 15.5026C14.4362 16.101 15.368 16.1691 15.9862 15.6547C16.6043 15.1403 16.6746 14.2381 16.1433 13.6397L13.3211 10.4616C12.6962 11.2055 11.9107 11.8178 11.0158 12.2491Z" fill="#13A546"/>
                                        </svg>
                                        ДОКТУ
                                    </button>
                                    <button v-if="isYandexMapsOn" type="button" class="btn btn-white">
                                        <svg width="16" height="16" viewBox="0 0 13 15">
                                            <path d="M6.5 0C3.19 0 0.5 2.69 0.5 6C0.5 7.66 1.17 9.16 2.26 10.24C3.35 11.33 5.9 12.9 6.05 14.55C6.07 14.8 6.25 15 6.5 15C6.75 15 6.93 14.8 6.95 14.55C7.1 12.9 9.66 11.33 10.74 10.24C11.83 9.15 12.5 7.65 12.5 6C12.5 2.69 9.81 0 6.5 0Z" fill="#FF4433"/>
                                            <path d="M6.49999 8.10039C7.65999 8.10039 8.59999 7.16039 8.59999 6.00039C8.59999 4.84039 7.65999 3.90039 6.49999 3.90039C5.33999 3.90039 4.39999 4.84039 4.39999 6.00039C4.39999 7.16039 5.33999 8.10039 6.49999 8.10039Z" fill="white"/>
                                        </svg>
                                        Яндекс Карты
                                    </button>
                                    <button v-if="is2GisOn" type="button" class="btn btn-white">
                                        <svg width="16" height="16" viewBox="0 0 16 15">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15C12.125 15 15.5 11.64 15.5 7.5C15.5 3.36 12.125 0 8 0C3.875 0 0.5 3.36 0.5 7.5C0.5 11.64 3.86 15 8 15Z" fill="#19AA1E"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5498C10.475 2.5498 12.155 4.4548 12.155 6.5098C12.155 7.3348 11.975 8.0548 11.555 8.9548C9.095 8.9548 8.645 10.5898 8.54 11.6848L8.465 12.4498H7.535L7.46 11.6848C7.355 10.5898 6.905 8.9548 4.445 8.9548C4.025 8.0548 3.845 7.3348 3.845 6.5098C3.845 4.4548 5.525 2.5498 8 2.5498Z" fill="white"/>
                                        </svg>
                                        2ГИС
                                    </button>
                                    <button v-if="isGoogleOn" type="button" class="btn btn-white">
                                        <svg width="16" height="16" viewBox="0 0 13 15">
                                            <path d="M3.30428 11.8531C3.8356 12.4705 4.37673 13.2468 4.65991 13.7157C5.00478 14.3253 5.14777 14.7369 5.40432 15.4741C5.55432 15.8779 5.69732 16.0004 5.99732 16.0004C6.32537 16.0004 6.47537 15.7946 6.59032 15.4741C6.83005 14.7825 7.0151 14.2563 7.30809 13.7548C8.43802 11.7749 10.2801 10.3682 11.3175 8.4404C11.3175 8.4404 12.0002 7.2629 12.0002 5.61388C12.0002 4.07688 11.3273 3.00879 11.3273 3.00879L3.30848 11.8661L3.30428 11.8531Z" fill="#34A853"/>
                                            <path d="M0.584493 8.23157C1.23077 9.59924 2.46314 10.798 3.30428 11.8531L7.7622 6.94205C7.7622 6.94205 7.13275 7.70795 5.99581 7.70795C4.7285 7.70795 3.6967 6.77011 3.6967 5.5848C3.6967 4.76941 4.21961 4.2041 4.21961 4.2041C0.939173 4.65739 1.12142 5.39593 0.574679 8.22896L0.584493 8.23157Z" fill="#FBBC04"/>
                                            <path d="M7.81824 0.255859C9.30425 0.700027 10.566 1.63656 11.323 3.00423L7.76216 6.95094C7.76216 6.95094 8.28507 6.38303 8.28507 5.57024C8.28507 4.36018 7.18599 3.44709 5.99998 3.44709C4.81398 3.44709 4.23359 4.20387 4.23359 4.20387C4.50696 3.62554 7.33178 0.452544 7.82245 0.257162L7.81824 0.255859Z" fill="#4285F4"/>
                                            <path d="M1.39755 1.99289C2.28355 1.01338 3.83685 0 5.98175 0C7.01775 0 7.80422 0.255299 7.80422 0.255299L4.22938 4.20201C3.98826 4.08048 1.63587 2.37845 1.39755 1.98768V1.99289Z" fill="#1A73E8"/>
                                            <path d="M0.584493 8.23157C0.584493 8.23157 0 7.15352 0 5.60088C0 4.12901 0.619638 2.83949 1.4019 2.00586L4.23373 4.22019L0.588797 8.23202L0.584493 8.23157Z" fill="#EA4335"/>
                                        </svg>
                                        Google
                                    </button>
                                </div>
                                <div class="agreement">
                                    Выражая свое мнение о&nbsp;качестве обслуживания, вы&nbsp;соглашаетесь с&nbsp;<a href="#">правилами сервиса</a>.
                                </div>
                            </section>
                        </div>
                    </div>

                    <fieldset :disabled="!isSupport">
                        <legend>Ссылки на карты</legend>

                        <label>Заголовок</label>
                        <vee-input v-model="settings.map_links_title"
                                   ref="mapLinksTitle"
                                   :rules="{required: true, max: 200}"
                                   :disabled="!isSupport"
                                   name="Заголовок ссылок на карты"/>

                        <label>Текст</label>
                        <vee-textarea v-model="settings.map_links_text"
                                      ref="mapLinksText"
                                      :rules="{required: true, max: 500}"
                                      :disabled="!isSupport"
                                      @input="setTextareaHeight"
                                      ta-class="appearanceSettingsText"
                                      name="Текст ссылок на карты"/>

                        <button :disabled="!isSupport" class="tiny" @click.prevent="setDefaultMapLinksText">
                            Стандартный текст
                        </button>
                    </fieldset>
                </div>

                <div class="appearanceSettingsRow">
                    <div class="clinic-review-wrap phonePreview">
                        <div class="clinic-review-service">
                            <div class="clinic-review-service__slide slide-3">
                                <h2 class="clinic-review-service__title">
                                    {{ settings.negativity_capture_title ? settings.negativity_capture_title : 'Напишите директору' }}
                                </h2>
                                <p class="clinic-review-service__txt">{{ settings.negativity_capture_text ? settings.negativity_capture_text : 'Расскажите, что не понравилось в ходе визита или что нужно улучшить, на ваш взгляд. Представитель клиники свяжется с вами и поможет решить проблему.' }}</p>
                                <div class="field field-textarea">
                                    <div class="field-textarea__wrap">
                                        <textarea placeholder="Расскажите подробнее о вашей ситуации (минимум 50 символов)"/>
                                    </div>
                                </div>
                                <div class="form-actions">
                                    <button type="button" class="btn btn-grey">Отправить</button>
                                </div>
                                <div class="agreement">
                                    Выражая свое мнение о&nbsp;качестве обслуживания, вы&nbsp;соглашаетесь с&nbsp;<a href="#">правилами сервиса</a>.
                                </div>
                            </div>
                        </div>
                    </div>

                    <fieldset :disabled="!isSupport">
                        <legend>Перехват негатива</legend>

                        <label>Заголовок</label>
                        <vee-input v-model="settings.negativity_capture_title"
                                   ref="negativityCaptureTitle"
                                   :rules="{required: true, max: 200}"
                                   :disabled="!isSupport"
                                   name="Заголовок перехвата негатива"/>

                        <label>Текст</label>
                        <vee-textarea v-model="settings.negativity_capture_text"
                                      ref="negativityCaptureText"
                                      :rules="{required: true, max: 500}"
                                      :disabled="!isSupport"
                                      @input="setTextareaHeight"
                                      ta-class="appearanceSettingsText"
                                      name="Текст перехвата негатива"/>

                        <button :disabled="!isSupport" class="tiny" @click.prevent="setDefaultNegativityCaptureText">
                            Стандартный текст
                        </button>
                    </fieldset>
                </div>

                <footer style="margin-top: 5px">
                    <button :class="[{loading: loading, green: isSupport && !noChanges}]"
                            :disabled="!isSupport || noChanges"
                            @click.prevent="save">
                        Сохранить
                    </button>
                </footer>
            </div>
        </ValidationObserver>
    </main>
</template>

<script>
import Alert from "../../../components/common/Alert.vue";

export default {
    components: { Alert },
    props: {
        defaultSettings: {
            type: Object,
            required: true,
        },
        isSupport: {
            type: Boolean,
            required: true,
        },
        clinicNamePrepositional: {
            type: String,
            required: true,
        },
        isYandexMapsOn: {
            type: Boolean,
            required: true,
        },
        is2GisOn: {
            type: Boolean,
            required: true,
        },
        isDoctuOn: {
            type: Boolean,
            required: true,
        },
        isGoogleOn: {
            type: Boolean,
            required: true,
        },
    },
    data: function () {
        const settings = {
            message_text: this.defaultSettings.message_text,
            review_title: this.defaultSettings.review_title,
            review_text: this.defaultSettings.review_text,
            like_button_text: this.defaultSettings.like_button_text,
            dislike_button_text: this.defaultSettings.dislike_button_text,
            map_links_title: this.defaultSettings.map_links_title,
            map_links_text: this.defaultSettings.map_links_text,
            negativity_capture_title: this.defaultSettings.negativity_capture_title,
            negativity_capture_text: this.defaultSettings.negativity_capture_text,
        };

        return {
            settings: settings,
            loading: false,
            messageTextError: '',
            originalData: JSON.parse(JSON.stringify(settings)),
        };
    },
    methods: {
        save() {
            if (this.loading || !this.isSupport || this.noChanges) {
                return;
            }

            this.loading = true;

            this.$refs.validator.validate().then(success => {
                if (this.settings.message_text && this.settings.message_text.indexOf('[ссылка]') === -1) {
                    this.messageTextError = 'В тексте обязательно должна быть переменная [ссылка]';
                } else {
                    this.messageTextError = '';
                }

                if (!success || this.messageTextError) {
                    this.loading = false;
                    return;
                }

                this.originalData = JSON.parse(JSON.stringify(this.settings));

                this.axios.post('appearance/save', this.settings).then(() => {
                    this.loading = false;
                });
            });
        },
        setDefaultMessageText() {
            this.settings.message_text = '[имя], расскажите, как прошел визит в клинику - [ссылка]';
            setTimeout(this.setTextareaHeight, 50);
        },
        setDefaultReviewText() {
            this.settings.review_title = 'Вам понравилось в ' + this.clinicNamePrepositional + '?';
            this.settings.review_text = 'Поделитесь мнением о качестве обслуживания в медицинском центре.';
            this.settings.like_button_text = 'Да, все отлично';
            this.settings.dislike_button_text = 'Нет, есть претензии';
            setTimeout(this.setTextareaHeight, 50);
        },
        setDefaultMapLinksText() {
            this.settings.map_links_title = 'Оставьте отзыв о ' + this.clinicNamePrepositional;
            this.settings.map_links_text = 'Поделитесь своим отзывом с другими пациентами на любом из сайтов на выбор.';
            setTimeout(this.setTextareaHeight, 50);
        },
        setDefaultNegativityCaptureText() {
            this.settings.negativity_capture_title = 'Напишите директору';
            this.settings.negativity_capture_text = 'Расскажите, что не понравилось в ходе визита или что нужно улучшить, на ваш взгляд. Представитель клиники свяжется с вами и поможет решить проблему.';
            setTimeout(this.setTextareaHeight, 50);
        },
        prepareTextForPreview(text) {
            return text.replaceAll('[имя]', 'Олег').replaceAll('[ссылка]', 'https://doctu.ru/');
        },
        setTextareaHeight() {
            document.querySelectorAll('.appearanceSettingsText').forEach(el => {
                el.style.height = '75px';
                el.style.height = Math.max(75, 5 + el.scrollHeight) + 'px';
            })
        }
    },
    computed: {
        noChanges() {
            return JSON.stringify(this.originalData) === JSON.stringify(this.settings);
        }
    },
    watch: {
        'settings.message_text'(newVal, oldVal) {
            if (newVal.length > 500) {
                this.settings.message_text = oldVal;
                this.$refs.messageText.innerValue = oldVal;
            }
        },
        'settings.review_title'(newVal, oldVal) {
            if (newVal.length > 200) {
                this.settings.review_title = oldVal;
                this.$refs.reviewTitle.innerValue = oldVal;
            }
        },
        'settings.review_text'(newVal, oldVal) {
            if (newVal.length > 500) {
                this.settings.review_text = oldVal;
                this.$refs.reviewText.innerValue = oldVal;
            }
        },
        'settings.like_button_text'(newVal, oldVal) {
            if (newVal.length > 30) {
                this.settings.like_button_text = oldVal;
                this.$refs.likeButtonText.innerValue = oldVal;
            }
        },
        'settings.dislike_button_text'(newVal, oldVal) {
            if (newVal.length > 30) {
                this.settings.dislike_button_text = oldVal;
                this.$refs.dislikeButtonText.innerValue = oldVal;
            }
        },
        'settings.map_links_title'(newVal, oldVal) {
            if (newVal.length > 200) {
                this.settings.map_links_title = oldVal;
                this.$refs.mapLinksTitle.innerValue = oldVal;
            }
        },
        'settings.map_links_text'(newVal, oldVal) {
            if (newVal.length > 500) {
                this.settings.map_links_text = oldVal;
                this.$refs.mapLinksText.innerValue = oldVal;
            }
        },
        'settings.negativity_capture_title'(newVal, oldVal) {
            if (newVal.length > 200) {
                this.settings.negativity_capture_title = oldVal;
                this.$refs.negativityCaptureTitle.innerValue = oldVal;
            }
        },
        'settings.negativity_capture_text'(newVal, oldVal) {
            if (newVal.length > 500) {
                this.settings.negativity_capture_text = oldVal;
                this.$refs.negativityCaptureText.innerValue = oldVal;
            }
        },
    },
    mounted() {
        this.setTextareaHeight();
    }
}
</script>

<style lang="scss">
@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap);

.appearanceSettingsForm {
    .appearanceSettingsRow {
        display: flex;
        margin-bottom: 10px;

        fieldset {
            width: 600px;
            align-self: flex-start;
            margin-left: 15px;

            textarea.appearanceSettingsText {
                overflow: hidden;
                height: 78px;
                min-height: 78px;
            }
        }

        .phonePreview {
            zoom: 0.8;
            margin: 0;
            pointer-events: none;
            user-select: none;
            cursor: default;
            font-family: 'Open Sans', sans-serif;
            color: #000000;
        }
    }
    .component-alert {
        width: 942px;
    }

    .clinic-review-wrap {
        background: url(/img/iphone.svg) no-repeat scroll center / cover transparent;
        aspect-ratio: 1 / 2.0313;
        padding: 8.5em 20px 1em;
        margin: 100px auto;
        max-width: 415px;
        width: 100%;
        box-sizing: border-box;
        container-type: inline-size;
        padding-top: 118px; // кастомный стиль
    }

    @mixin mobile {
        padding: 0 16px 24px;

        &__title {
            font-size: 28px;
            margin-top: 24px;
        }

        &__txt {
            font-size: 16px;
            white-space: pre-line;
        }

        .btn {
            font-size: 16px;
            line-height: 16px;
            font-weight: 600;
            font-family: 'Open Sans', sans-serif !important;
            border-radius: 4px;
            text-shadow: none;

            &.btn-white:hover {
                background: #574FB8;
                border-color: #574FB8;
                color: #fff;
            }

            &.btn-green:hover {
                background: #0a8036;
                color: #fff;
                border: none;
            }

            &.btn-grey, &.btn-grey:hover {
                background: #BDBDBD;
                color: #fff;
                border: none;
            }
        }

        .field-textarea {
            textarea {
                font-size: 16px;
                line-height: 1.4;
                height: 100%;
                border: 1px solid #DDD9EA !important;
                border-radius: 4px !important;
            }
            textarea::-moz-placeholder {
                color: #9896AE;
            }
            textarea::placeholder {
                color: #9896AE;
            }
            textarea::-webkit-resizer {
                background: url("/img/corner.svg") no-repeat right 2px bottom 2px;
            }
        }

        .agreement {
            font-size: 14px;
            line-height: 1.2;
            margin-top: 16px;
            color: #9896AE;
        }

        a {
            color: #2C2B67;
            border-bottom: none;
        }
    }

    .clinic-review-service {
        box-sizing: border-box;

        margin: 0 auto;
        max-width: 900px;
        padding: 0 16px 48px;
        width: 100%;

        &__title {
            font-size: 40px;
            line-height: 1.1;
            font-weight: 700;
            margin-top: 48px;
        }

        &__txt {
            font-size: 20px;
            margin-top: 16px;
            line-height: 1.4;
        }

        .field-textarea {
            margin-top: 16px;

            &__wrap {
                height: 150px;
            }

            textarea {
                font-size: 20px;
                line-height: 28px;
                padding: 16px;
            }
        }

        .form-actions {
            display: flex;
            margin-top: 32px;
            flex-direction: column;
            gap: 16px;
        }

        .agreement {
            font-size: 16px;
            line-height: 1.2;
            margin-top: 16px;
        }

        .btn {
            flex: 1 1 auto;
            padding: 15px;
            height: 48px;
            font-size: 20px;
            line-height: 20px;
            gap: 6px;

            svg {
                //display: block;
                line-height: 1;
            }
        }

        @container (max-width: 767px) {
            @include mobile;
        }

        @media (max-width: 767px) {
            @include mobile;
        }
    }

    .clinic-review-service-iphone-message {
        background: url(/img/iphone-result.svg) no-repeat scroll center / cover transparent;
        aspect-ratio: 1 / 1.2224;
        padding: 16.5em 22px 1em;
        margin: 100px auto;
        max-width: 409px;
        width: 100%;
        box-sizing: border-box;
        container-type: inline-size;

        .message {
            background: url(/img/iphone-result-message.svg) no-repeat scroll center top/ 100% auto #393939;
            border-radius: 20px;
            box-sizing: border-box;
            color: #fff;
            padding: 31px 10px 20px 60px;
            font-size: 15px;
            font-weight: 500;
            line-height: 1.2;
            white-space: pre-line;
            min-height: 100px;
        }
    }
}

</style>
